import React from "react";
import PropTypes from "prop-types";
import { FilterSelect, inlineSelectComponents } from "@td/ui";
import { priorityCodes } from "../constants";
import { translate } from "@td/shared_utils";

const { CheckboxOption } = inlineSelectComponents;

const options = [
  {
    value: priorityCodes.URGENT,
    label: translate(null, "care_team_tasks.priorities", "URGENT"),
  },
];

const filterDropdownProps = {
  style: {
    minWidth: 140,
  },
  "data-testid": "priority-filter",
};

const PriorityFilter = React.memo((props) => (
  <FilterSelect
    {...props}
    isMulti
    isSearchable={false}
    options={options}
    label={translate(null, "care_team_tasks.filters.fields.priority", "label")}
    filterDropdownProps={filterDropdownProps}
    components={{
      Option: CheckboxOption,
      Control: () => null,
    }}
  />
));

PriorityFilter.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

PriorityFilter.displayName = "PriorityFilter";

export default PriorityFilter;
